import { render, staticRenderFns } from "./SupplierAdd.vue?vue&type=template&id=4c61f0aa&"
import script from "./SupplierAdd.vue?vue&type=script&lang=js&"
export * from "./SupplierAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports